// input.module.ts
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AsMultiselectComponent } from './multiselect.component';
import { OverlayModule } from '@angular/cdk/overlay';
 
 
 

@NgModule({
  declarations: [AsMultiselectComponent ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, OverlayModule ],
  exports: [AsMultiselectComponent ]
})
export class AsMultiselectModule  {}
